export default {
    install: (app) => {
        app.config.globalProperties.$openDocument = (link) => {
            const url = new URL(link, process.env.VUE_APP_API_URL || window.location.origin)
            url.searchParams.set('t', app.config.globalProperties.$store.state.user.token)
            window.open(url.href, '_blank')
        }
    },
}
